'use client';

import * as React from 'react';
import { cn } from '@/core/lib/utils';
import { Icon } from './Icon';
import { iTickSquare } from '@pte/react-icons';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, value, disabled, readOnly, ...props }, ref) => {
    const generatedId = React.useId();
    const checkboxId = id || generatedId;
    const checked = props.checked;
    return (
      <label
        className={cn(
          'relative inline-flex items-center gap-2 cursor-pointer',
          (disabled || readOnly) && 'pointer-events-none'
        )}
        htmlFor={checkboxId}
        data-pte-name='checkbox'
      >
        <input
          type='checkbox'
          id={checkboxId}
          ref={ref}
          className='peer sr-only'
          disabled={disabled}
          readOnly={readOnly}
          value={value}
          checked={checked}
          onChange={props.onChange}
          data-pte-name='checkbox-input'
          {...props}
        />
        <span
          className={cn(
            'text-primary hover:text-primary/80 border border-black rounded-sm w-[20px] h-[20px]',
            className,
            checked && 'border-primary',
            (disabled || readOnly) &&
              'icon-disable border-icon-gray-400 hover:border-gray-400 hover:text-gray-400 cursor-not-allowed user-select-none'
          )}
          data-pte-name='checkbox-indicator'
        >
          {checked && (
            <Icon
              icon={iTickSquare}
              size={22}
              className='mt-[-2px] ml-[-2px]'
            />
          )}
          {/* <Icon icon={iTickSquare} size={22} /> */}
          {/* <Icon icon={iSquare} color='white' size={22} stroke='black' /> */}
        </span>
        {label && (
          <span
            className='text-[14px] leading-[1.2]'
            data-pte-name='checkbox-label'
          >
            {label}
          </span>
        )}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
